import { MembersReportData } from 'fitbeat.models';
import React from 'react';
import { Card, CardText, CardTitle } from 'reactstrap';

interface IProps {
  report: MembersReportData;
  isActive: boolean;
  numberOfRowsInReport: number;
  onClick: (report: MembersReportData) => void;
}

export class DashboardReportTile extends React.PureComponent<IProps> {
  public render() {
    const {
      report,
      isActive,
      numberOfRowsInReport,
    } = this.props;

    const containerClass = `dashboard-report-card-container ${isActive ? 'active' : ''}`;

    return (
      <Card
        className={containerClass}
        onClick={this.handleClick}
      >
        <div className='dashboard-report-card-title-container'>
          <CardTitle tag='p' className='dashboard-report-card-title'>
            {numberOfRowsInReport}
          </CardTitle>
        </div>
        <div className='dashboard-report-card-sub-title-container'>
          <CardText className='dashboard-report-card-sub-title'>
            {report.reportName}
          </CardText>
        </div>
      </Card>
    );
  }

  private handleClick = () => {
    this.props.onClick(this.props.report);
  }
}
